module.exports = __webpack_public_path__ + "img/color-picker.23551635.svg";